import React, { useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
  Divider,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const DietaryEditorField = ({ dietaryOptions, setDietaryOptions, sizes }) => {
  useEffect(() => {
    setDietaryOptions((prevOptions) =>
      prevOptions.map((opt) => {
        const updatedAdjustments = sizes.map((size) => {
          const existing = opt.priceAdjustments.find(
            (adj) => String(adj.sizeId) === String(size.sizeId)
          );
          return existing || { sizeId: size.sizeId, amount: 0 };
        });

        return { ...opt, priceAdjustments: updatedAdjustments };
      })
    );
  }, [sizes]);

  const handleAdd = () => {
    setDietaryOptions((prev) => [
      ...prev,
      {
        type: "",
        priceAdjustments: sizes.map((s) => ({
          sizeId: s.sizeId,
          amount: 0,
        })),
      },
    ]);
  };

  const handleTypeChange = (index, value) => {
    setDietaryOptions((prev) =>
      prev.map((opt, i) => (i === index ? { ...opt, type: value } : opt))
    );
  };

  const handlePriceChange = (dietIndex, sizeId, newAmount) => {
    setDietaryOptions((prev) => {
      const updated = [...prev]; // deep copy
      const opt = { ...updated[dietIndex] };
      const adjustments = opt.priceAdjustments.map((adj) =>
        String(adj.sizeId) === String(sizeId)
          ? { ...adj, amount: newAmount }
          : adj
      );
      opt.priceAdjustments = adjustments;
      updated[dietIndex] = opt;
      console.log("Before return:", JSON.stringify(prev[dietIndex], null, 2));

      return updated;
    });
  };

  const handleDelete = (index) => {
    setDietaryOptions((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography fontWeight="bold" sx={{ mb: 1 }}>
        Dietary Options
      </Typography>

      {dietaryOptions.map((option, index) => (
        <Box
          key={index}
          sx={{
            mb: 3,
            p: 2,
            border: "1px solid #eee",
            borderRadius: 2,
            backgroundColor: "#fafafa",
          }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
            <TextField
              label="Type"
              value={option.name}
              onChange={(e) => handleTypeChange(index, e.target.value)}
              size="small"
            />
            <IconButton onClick={() => handleDelete(index)} size="small">
              <DeleteIcon />
            </IconButton>
          </Box>

          {sizes.map((size) => {
            const priceAdj = option.priceAdjustments.find(
              (adj) => String(adj.sizeId) === String(size.sizeId)
            );

            return (
              <Box
                key={size.sizeId}
                sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                <Typography sx={{ width: 120 }}>{size.name}</Typography>
                <TextField
                  label="Extra Cost"
                  type="number"
                  size="small"
                  value={
                    priceAdj?.amount === 0 ||
                    typeof priceAdj?.amount === "number"
                      ? priceAdj.amount
                      : ""
                  }
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const parsed = inputValue === "" ? "" : Number(inputValue);
                    handlePriceChange(index, size.sizeId, parsed);
                  }}
                  inputProps={{ step: 0.5, min: 0 }}
                />
              </Box>
            );
          })}
        </Box>
      ))}

      <Divider sx={{ my: 2 }} />

      <Button
        startIcon={<AddIcon />}
        onClick={handleAdd}
        size="small"
        variant="outlined">
        Add Dietary Option
      </Button>
    </Box>
  );
};

export default DietaryEditorField;
